import { all } from 'ramda';
import { useMemo } from 'react';
import { mediaManagerFileChosen, mediaManagerFileChosenTry } from '@wix/bi-logger-media-data/v2';
import { mediaManagerFileChosenParams } from '@wix/bi-logger-media-data/v2/types';
import { bi } from '../../../services/loggers/bi';
import { extractCommonBiFieldsFromItems } from '../../bi';
import { isFile } from '../../media-manager-sdk/items';
import { useFileType } from './useFileType';
import { useSearchResultsBI } from '../../../containers/FilesManager/SearchResults/useSearchResultsBI';
import { useRelatedItems } from '../../hoc/withRelatedItems/withRelatedItems';
import { SelectedItemType } from '../../hoc/withItemsReducer/withItemsReducer.types';

export const useTrackItemsSubmittedAnalytics = () => {
  const fileType = useFileType();
  const { searchId, searchMetaInfo } = useSearchResultsBI();
  const { relatedItemsMetaInfo } = useRelatedItems();

  return useMemo(
    () => ({
      trackMediaManagerFileChosenTry: (items) => {
        if (!all(isFile, items)) {
          return;
        }

        bi.logger().report(mediaManagerFileChosenTry(extractCommonBiFieldsFromItems(items, { fileType })));
      },
      trackMediaManagerFileChosen: ({
        items,
        category,
        categoryId,
        searchTerm,
        orientation,
        target,
        selectedItemTypes = {},
      }) => {
        if (!all(isFile, items)) {
          throw new Error('Cannot submit file selection to bi');
        }

        const firstItem = items[0];
        const isFirstItemRelated = selectedItemTypes[firstItem?.id] === SelectedItemType.RelatedItem;
        const metaInfo = isFirstItemRelated ? relatedItemsMetaInfo : searchMetaInfo;

        let sectionParams = {};

        if (firstItem && metaInfo?.[firstItem.id]) {
          const firstItemMeta = metaInfo[firstItem.id];

          sectionParams = {
            section_name: firstItemMeta.sectionName,
            section_index: firstItemMeta.sectionIndex,
            clicked_file_index: firstItemMeta.itemIndexWithinCategory,
          };
        }

        const params: mediaManagerFileChosenParams = {
          ...extractCommonBiFieldsFromItems(items, { fileType }),
          category,
          categoryId,
          searchTerm,
          orientation,
          target,
          search_id: searchId,
          ...sectionParams,
        };

        bi.logger().report(mediaManagerFileChosen(params));
      },
    }),
    [fileType, searchId, searchMetaInfo, relatedItemsMetaInfo],
  );
};
